import PropTypes from "prop-types";

const BtnSecondaryS = ({ buttonCTA, onClickLink, type }) => {
  return (
    <button
      className="btn-secondary-s text-sm md:text-sm"
      onClick={onClickLink}
      type={type}
    >
      {buttonCTA}
    </button>
  );
};

BtnSecondaryS.propTypes = {
  buttonCTA: PropTypes.string.isRequired,
  onClickLink: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default BtnSecondaryS;
